import _ from 'lodash'
export default {
  props: {
    giftData: {
      type: Object,
      required: false
    }
  },
  computed: {
    giftSelection () {
      return _.get(this.$store.state.selectedGifts, [this.giftData.id, this.productData.productId]) || false
    }
  },
  methods: {
    updateGiftSelection (changeEvent) {
      const dispatchAction = (this.giftSelection) ? 'removeGiftFromSelection' : 'addGiftToSelection'
      this.$store.dispatch(dispatchAction, {
        giftId: this.giftData.id,
        productId: this.productData.productId
      })
    }
  }
}
